import {action, makeObservable, observable, runInAction} from 'mobx'
import {PageData} from '@/src/core/domain/entities/page/page-data'
import {PageStoreInterface} from '@/src/ports/store/page-store'
import {isWeb} from '@/src/shared/utils/functions'
import type {LoadPageDataParams} from '@/src/core/domain/page'

export class PageStore<T = any> implements PageStoreInterface<T> {
  @observable
  loaded = isWeb()

  @observable
  pageData: Nullable<PageData<T>> = null

  @observable
  queryKey: any[] = []

  @observable
  loadingParams: Nullable<LoadPageDataParams> = null

  @observable
  session?: Session | null

  constructor(pageData: Nullable<PageData<T>>, queryKey: any[] = []) {
    runInAction(() => {
      this.setPageData(pageData, queryKey)
    })

    makeObservable(this)
  }

  @action.bound
  setLoaded(loaded: boolean) {
    this.loaded = loaded
  }

  @action.bound
  setPageData(pageData: Nullable<PageData<T>>, queryKey: any[]) {
    this.pageData = pageData
    this.queryKey = queryKey
    this.session = this.pageData?.session ?? null
    if (pageData) {
      this.setLoaded(true)
    }
  }

  @action.bound
  setPageQueryKey(queryKey: any[]) {
    this.queryKey = queryKey
  }

  @action.bound
  setSession(session: Nullable<Session>) {
    this.session = session
  }
}
